import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { HostBinding, Component, ChangeDetectionStrategy } from '@angular/core';
import { appAnimations } from '@shared/animations';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { ConfigService, GTagService, FocusService, AnnounceService } from '@shared/services';

@Component({
  selector: 'app-feature-modules',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
  animations: appAnimations,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeaturesComponent {
  private previosUrl: string = '';
  private lastPath: string = null;
  private appSettings: any;
  private announceTimeoutId: any;
  private focusTimeoutId: any;
  private isFirstNavigation = true;

  // @HostBinding( '@routerTransitionUp' ) routeAnimationUp = false;
  // @HostBinding( '@routerTransitionDown' ) routeAnimationDown = false;
  @HostBinding('@routerTransitionRight') routeAnimationRight = false;
  @HostBinding('@routerTransitionLeft') routeAnimationLeft = false;
  @HostBinding('@routerTransitionFade') routeAnimationFade = false;

  constructor(
    private title: Title,
    private router: Router,
    private location: Location,
    private gTag: GTagService,
    private appConfig: ConfigService,
    private announcer: AnnounceService,
    private focusService: FocusService,
  ) {
    this.router.events
      .pipe(
        takeUntilDestroyed(),
        filter((event) => event instanceof NavigationEnd),
      )
      .subscribe((event: NavigationEnd) => {
        switch (this.appSettings.routerAnimation) {
          case 'fadeIn':
            this.routeAnimationFade = !this.routeAnimationFade;
            break;
          // case 'slideUp':
          // 	this.routeAnimationUp = !this.routeAnimationUp;
          // 	break;
          // case 'slideDown':
          // 	this.routeAnimationDown = !this.routeAnimationDown;
          // 	break;
          case 'slideRight':
            if (this.previosUrl.includes('simulator')) {
              this.routeAnimationRight = !this.routeAnimationRight;
            }
            break;
          case 'slideLeft':
            if (this.previosUrl.includes('program')) {
              this.routeAnimationLeft = !this.routeAnimationLeft;
            }
            break;
        }

        this.previosUrl = event.url;

        // A site navigation leaves the popup outlet mounted and leaks it into the URL.
        // Clearing it destroys CaseComponent, whose ngOnDestroy overwrites the new layout.
        const path = this.location.path();
        if (path !== this.lastPath) {
          this.lastPath = path;
          this.announcePageChange();
          if (this.gTag.isGTagAvailable) {
            this.gTag.sendPageView(path);
          }
          if (this.router.url.includes('program-popup')) {
            const pageSettings = this.appConfig.settings;
            this.router
              .navigate([{ outlets: { 'program-popup': null } }], {
                replaceUrl: true,
              })
              .then(() => this.appConfig.setSettings(pageSettings));
          }
        }

        if (!this.isFirstNavigation) {
          this.moveFocusToContent();
        }
        this.isFirstNavigation = false;
      });

    this.appConfig.onSettingsChanged.pipe(takeUntilDestroyed()).subscribe((newSettings) => {
      this.appSettings = newSettings;
    });
  }

  private announcePageChange() {
    clearTimeout(this.announceTimeoutId);
    this.announceTimeoutId = setTimeout(() => {
      const pageTitle = this.title.getTitle();
      this.announcer.announce(`Page loaded: ${pageTitle}`, 'assertive');
    }, 150);
  }

  private moveFocusToContent() {
    clearTimeout(this.focusTimeoutId);
    this.focusTimeoutId = setTimeout(() => {
      if (!this.focusService.isFocusWithin(FocusService.PAGE_ID)) {
        this.focusService.focusPage();
      }
    }, 150);
  }
}
